import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Partners.css";

// 1) Put your logos in: src/assets/partners/
// 2) Update these imports to match your filenames
import lenovoLogo from "../../assets/images/partners/lenovo.png";
import microsoftLogo from "../../assets/images/partners/microsoft.png";

// Example imports (replace with your actual list from Logos-1.docx exports)
import logoaws from "../../assets/images/partners/aws.png";
import logofortinet from "../../assets/images/partners/fortinet.png";
import logoruckus from "../../assets/images/partners/ruckus.png";
import logoServiceNow from "../../assets/images/partners/ServiceNow.png";
import logoNetgear from "../../assets/images/partners/Netgear.png";
import logoBarco from "../../assets/images/partners/Barco.png";
import logoBarracuda from "../../assets/images/partners/Barracuda.png";
import logoBitdefender from "../../assets/images/partners/Bitdefender.png";
import logoCisco from "../../assets/images/partners/Cisco.png";
import logoextremenetworks from "../../assets/images/partners/extremenetworks.png";
import logoOwlLabs from "../../assets/images/partners/OwlLabs.jpg";
import logoBroadcom from "../../assets/images/partners/Broadcom.jpg";
import logoCloudflare from "../../assets/images/partners/Cloudflare.png";
import logoconnectwise from "../../assets/images/partners/connectwise.png";
import logoEkahaubyOokla from "../../assets/images/partners/Ekahau-by-Ookla.jpg";
import logoHewlettPackardEnterprise from "../../assets/images/partners/HewlettPackardEnterprise.png";
import logoHPEJuniperNetworking from "../../assets/images/partners/HPEJuniperNetworking.png";
import logoNutanix from "../../assets/images/partners/Nutanix.png";
import logoGoogleCloud from "../../assets/images/partners/Google-Cloud-Logo.png";
import logoDellTechnologies from "../../assets/images/partners/Dell_Technologies-Logo.png";
import logoIngramMicro from "../../assets/images/partners/ingram-micro-logo.png";
import logoTDSynnex from "../../assets/images/partners/td-synnex-logo.png";
import logosophosMsp from "../../assets/images/partners/Sophos MSP Partner.png";
import logosophosCloud from "../../assets/images/partners/Sophos Cloud Security.png";
import logoAlliedTelesis from "../../assets/images/partners/Allied Telesis.png";
import logotrellix from "../../assets/images/partners/trellix sky high security.jpg";
import logozscaler from "../../assets/images/partners/zscaler .png";
import logowatchguard from "../../assets/images/partners/watchguard.png";
import logoArrow from "../../assets/images/partners/Arrow electronics.jpg";
import logoNetApp from "../../assets/images/partners/NetApp.png";
import logoLogitech from "../../assets/images/partners/Logitech_Logo.png";

import logoBlackBerry  from "../../assets/images/partners/BlackBerry Cuts Cylance Spend to Focus on Profitable Areas.png";
import logoOmada  from "../../assets/images/partners/Omada Health Joins Amazon’s Health Condition Programs as Launch Partner____.png";
import logoUbiquitiNetworks from "../../assets/images/partners/Ubiquiti Networks Logo at Alton Phelps blog.png";
import logoVeeam from "../../assets/images/partners/Veeam logo and symbol, meaning, history, PNG.png";

const Partners = () => {
  const navigate = useNavigate();

  const topPartners = [
    { name: "Lenovo", logo: lenovoLogo, path: "/partners/Lenovo" },
    { name: "Microsoft", logo: microsoftLogo, path: "/partners/Microsoft" },
  ];

  const partners = [
    { name: "Allied Telesis", logo: logoAlliedTelesis, path: "/partners/AlliedTelesis" },
    { name: "Amazon Web Services", logo: logoaws, path: "/partners/AWS" },
    { name: "Barco", logo: logoBarco, path: "/partners/Barco" },
    { name: "Barracuda", logo: logoBarracuda, path: "/partners/Barracuda" },
    { name: "Bitdefender", logo: logoBitdefender, path: "/partners/Bitdefender" },
    { name: "Broadcom", logo: logoBroadcom, path: "/partners/Broadcom" },
    { name: "Cisco", logo: logoCisco, path: "/partners/Cisco" },
    { name: "Cloudflare", logo: logoCloudflare, path: "/partners/Cloudflare" },
    { name: "ConnectWise", logo: logoconnectwise, path: "/partners/Connectwise" },
    { name: "Dell Technologies", logo: logoDellTechnologies, path: "/partners/DellTechnologies" },
    { name: "Ekahau by Ookla", logo: logoEkahaubyOokla, path: "/partners/EkahauByOokla" },
    { name: "Extreme Networks", logo: logoextremenetworks, path: "/ExtremeNetworks" },
    { name: "Fortinet", logo: logofortinet, path: "/partners/Fortinet" },
    { name: "Google Cloud", logo: logoGoogleCloud, path: "/partners/GoogleCloud" },
    { name: "Hewlett Packard Enterprise", logo: logoHewlettPackardEnterprise, path: "/partners/HewlettPackardEnterprise" },
    { name: "HPE Juniper Networking", logo: logoHPEJuniperNetworking, path: "/partners/HPEJuniperNetworking" },
    { name: "Ingram Micro", logo: logoIngramMicro, path: "/partners/IngramMicro" },
    { name: "Lenovo", logo: lenovoLogo, path: "/partners/Lenovo" },
    { name: "Microsoft", logo: microsoftLogo, path: "/partners/Microsoft" },
    { name: "Netgear", logo: logoNetgear, path: "/partners/Netgear" },
    { name: "Nutanix", logo: logoNutanix, path: "/partners/Nutanix" },
    { name: "Owl Labs", logo: logoOwlLabs, path: "/partners/OwlLabs" },
    { name: "Ruckus", logo: logoruckus, path: "/partners/Ruckus" },
    { name: "ServiceNow", logo: logoServiceNow, path: "/partners/ServiceNow" },
    { name: "Sophos Cloud Security", logo: logosophosCloud, path: "/partners/SophosCloud" },
    { name: "Sophos MSP Partner", logo: logosophosMsp, path: "/partners/SophosMSP" },
    { name: "TDSynnex", logo: logoTDSynnex, path: "/partners/TDSynnex" },
    { name: "trellix", logo: logotrellix, path: "/partners/Trellixskyhigh" },
    { name: "zscaler", logo: logozscaler, path: "" },
    { name: "watchguard", logo: logowatchguard, path: "" },
    { name: "Arrow Electronics", logo: logoArrow, path: "" },
    { name: "NetApp", logo: logoNetApp, path: "" },
    { name: "Logitech", logo: logoLogitech, path: "" },
    { name: "BlackBerry Cylance ", logo: logoBlackBerry, path: "" },
    { name: "Omada", logo: logoOmada, path: "" },
    { name: "Ubiquiti Networks", logo: logoUbiquitiNetworks, path: "" },
    { name: "Veeam", logo: logoVeeam, path: "" },
  ];

  return (
    <div className="partnersPage">
      {/* Dark split hero */}
      <section className="partnersSplit">
        <div className="partnersSplit__grid-bg" aria-hidden="true"></div>

        <div className="partnersSplit__left">
          <div className="partnersEyebrow">
            <span className="live-dot" aria-hidden="true" />
            Our partners
          </div>

          <h1 className="partnersSplit__title">
            Digital transformation begins with the right partnerships.
          </h1>

          <p className="partnersSplit__text">
            We partner with proven technology leaders to deliver advanced
            solutions that support modern IT environments across networking,
            cloud, and cybersecurity.
          </p>
        </div>

        <div className="partnersSplit__right">
          <span className="scan-corner tl" aria-hidden="true" />
          <span className="scan-corner tr" aria-hidden="true" />
          <span className="scan-corner bl" aria-hidden="true" />
          <span className="scan-corner br" aria-hidden="true" />
        </div>
      </section>

      {/* Strategic alliance — top partners */}
      <section className="partnersLight">
        <div className="partnersContainer">
          <div className="partnersSectionHead">
            <div className="partnersEyebrow partnersEyebrow--dark">
              <span className="live-dot" aria-hidden="true" />
              Strategic alliance
            </div>
            <h2 className="partnersH2">Our Partners</h2>
          </div>

          <div className="partnersTopGrid">
            {topPartners.map((p) => (
              <article
                key={p.name}
                className="partnerCard"
                onClick={() => { if (p.path) navigate(p.path); }}
                style={{ cursor: p.path ? "pointer" : "default" }}
              >
                <div className="partnerCard__logoWrap">
                  <img className="partnerCard__logo" src={p.logo} alt={p.name} />
                  <span className="scan-corner tl" aria-hidden="true" />
                  <span className="scan-corner tr" aria-hidden="true" />
                  <span className="scan-corner bl" aria-hidden="true" />
                  <span className="scan-corner br" aria-hidden="true" />
                </div>

                <div className="partnerCard__meta">
                  <p className="partnerCard__name">{p.name}</p>
                  <span className="partnerCard__cta">
                    <svg
                      className="partnerCard__arrow"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M5 12h14M13 5l7 7-7 7" />
                    </svg>
                    <span className="partnerCard__underline" />
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Full logo grid */}
      <section className="partnersGridSection">
        <div className="partnersContainer">
          <div className="partnersGridHead">
            <span className="partnersGridHead__label">All partners</span>
            <span className="partnersGridHead__count">
              {String(partners.length).padStart(2, "0")} total
            </span>
          </div>

          <div className="partnersGrid">
  {partners.map((p) => (
    <article
      key={p.name}
      className="logoTile"
      onClick={() => {
        if (p.path) {
          navigate(p.path);
        }
      }}
      style={{
        cursor: p.path ? "pointer" : "default",
      }}
    >
      <div className="logoTile__box">
        <img className="logoTile__img" src={p.logo} alt={p.name} />
        <span className="scan-corner tl" aria-hidden="true" />
        <span className="scan-corner tr" aria-hidden="true" />
        <span className="scan-corner bl" aria-hidden="true" />
        <span className="scan-corner br" aria-hidden="true" />
      </div>

      <div className="logoTile__footer">
        <span className="logoTile__name">{p.name}</span>

        <span className="logoTile__cta">
          <svg
            className="logoTile__arrow"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M5 12h14M13 5l7 7-7 7" />
          </svg>

          <span className="logoTile__line" />
        </span>
      </div>
    </article>
  ))}
</div>
        </div>
      </section>

      {/* Let's meet CTA — namespaced as ppCta so it never collides with CTASection.css */}
      <section className="ppCta">
        <div className="ppCta__grid-bg" aria-hidden="true"></div>

        <div className="ppCta__panel">
          <span className="scan-corner tl" aria-hidden="true" />
          <span className="scan-corner tr" aria-hidden="true" />
          <span className="scan-corner bl" aria-hidden="true" />
          <span className="scan-corner br" aria-hidden="true" />

          <div className="ppCta__content">
            <div className="partnersEyebrow">
              <span className="live-dot" aria-hidden="true" />
              Get in touch
            </div>

            <h2 className="ppCta__title">Let's Meet</h2>

            <p className="ppCta__text">
              For more information about working with ALG Data Guard, give us
              a call or send us an email. We're here to help in any way.
            </p>

            <button className="ppCta__btn" onClick={() => navigate("/contact")}>
              Engage with an expert
              <svg
                className="ppCta__btn-arrow"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partners;
